import { render, staticRenderFns } from "./EventCategoryEdit.vue?vue&type=template&id=e09364ac"
import script from "./EventCategoryEdit.js?vue&type=script&lang=js&external"
export * from "./EventCategoryEdit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports